import { create } from "zustand";

export const useListingsStore = create((set) => ({
  shareListingPopupOpen: false,
  setShareListingPopupOpen: (value) => set({ shareListingPopupOpen: value }),

  listings: [],
  setListings: (value) => set({ listings: value }),
}));
